module.exports = __webpack_public_path__ + "img/face.752c047e.svg";